export default __webpack_public_path__ + "static/media/download-folder.5de8161c.svg";